<template lang="html">
  <div>
    <h1>Registro dei beni</h1>

    <div style="float: right">
      <Button @click.native="$root.$emit('inventory.show')" type="info">
        <Icon type="plus"></Icon>
        Carica
      </Button>
      &nbsp;
      <Button type="primary" @click.native="print_loading2 = true; $utils.download(`bilancio-${year}.pdf`, 'inventory', Object.assign({_print:2}, params), () => {print_loading2 = false})" :loading="print_loading2">
        Stampa
      </Button>
    </div>

    <Select v-model="filters.active">
      <Option :value="1">In essere</Option>
      <Option :value="0">Venduti o dismessi</Option>
    </Select>
    &nbsp;
    <Input v-model="filters.search" placeholder="Ricerca..."/>
    <br>
    <br>
    <span v-if="items && items.length">
      Totale cespiti sottostanti: {{ $n(_.sum(items.map(i => i.amount)), 'currency') }}
    </span>


    <div style="position: relative">
      <div class="ivu-table spaced" style="margin: 1em 0">
        <table>
          <thead>
            <tr>
              <th style="width: 100px; cursor: pointer" @click="orderBy('date')">
                Data
                <Icon v-if="filters.order && filters.order.by=='date'" :type="'ios-arrow-'+(filters.order.asc?'down':'up')"/>
              </th>
              <th style="cursor: pointer; width: 40%" @click="orderBy('name')">
                Nome bene
                <Icon v-if="filters.order && filters.order.by=='name'" :type="'ios-arrow-'+(filters.order.asc?'down':'up')"/>
              </th>
              <th style="; cursor: pointer" @click="orderBy('amount')">
                Importo
                <Icon v-if="filters.order && filters.order.by=='amount'" :type="'ios-arrow-'+(filters.order.asc?'down':'up')"/>
              </th>
              <th style="">Fornitore</th>
              <th style="">Stato</th>
              <th style="width: 200px"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!items.length">
              <td colspan=3>
                Nessun bene presente
              </td>
            </tr>
            <tr v-for="(item, it_i) in items" :key="item.id">
              <td>{{ item.date ? $d(new Date(item.date)) : '--/--/----' }}</td>
              <td style="">{{ item.name }}</td>
              <td>{{ $n(item.amount, 'currency') }}</td>
              <td>
                {{ item.bought_from }}
                {{ item.n_fatt }}
                <span v-if="item.item && item.item.invoice">
                  /
                  {{ item.item.invoice.date.split('-')[0] }}
                </span>
              </td>
              <td>
                <span v-if="item.disposal_tx">
                  {{ $d(Date.maintain(item.disposal_tx.date)) }}
                  <span>{{ item.is_sold ? '(venduto)' : '(dismesso)' }}</span>
                </span>
                <span v-else>Attivo</span>

                <a v-if="item.sell_invoice" @click="$root.$emit('invoice.show', item.sell_invoice)">
                  {{ item.sell_invoice.number }}
                  /
                  {{ item.sell_invoice.date.split('-')[0] }}
                </a>
                <span v-else>
                  <span v-if="item.is_sold">
                    Non disponibile
                  </span>
                </span>
              </td>
              <td>
                <ButtonGroup v-if="!item.disposal_tx">
                  <Button size="small" type="success" shape="circle" @click="form = {item, op: 'sell'}">
                    Vendi
                  </Button>
                  <Button size="small" type="info" shape="circle" @click="form = {item, op: 'dismiss'}">
                    Dismetti
                  </Button>
                  <Button v-if="!item.item" size="small" type="warning" shape="circle" @click="$root.$emit('inventory.show', item)">
                    <Icon type="edit"></Icon>
                  </Button>
                  <Button v-if="!item.item" size="small" type="error" shape="circle" @click="deleteItem(item, it_i, items)">
                    <Icon type="ios-trash"></Icon>
                  </Button>
                </ButtonGroup>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <Spin size="large" fix v-if="loading"/>
    </div>

    <Modal :value="!!form" @input="!$event && (form = null)" class-name="no-foot">
      <Form v-if="form"  :label-width="150" >
        <h1 v-if="form.op == 'sell'">
          Vendita bene: {{ form.item.name }}
        </h1>
        <h1 v-if="form.op == 'dismiss'">
          Dismissione bene: {{ form.item.name }}
        </h1>
        <hr>

        <template v-if="form.op == 'sell'">
          <FormItem label="Metodo di incasso">
            <Select v-model="form.ledger_id">
              <Option v-for="led in ledgers" :key="led.id" :value="led.id">
                [{{ led.code}}] {{ led.name }}
              </Option>
            </Select>
          </FormItem>
          <FormItem label="Ammontare">
            <NumInput v-model="form.amount"/>
          </FormItem>
          <FormItem label="Nome acquirente">
            <Input v-model="form.contact_name"/>
          </FormItem>
        </template>

        <FormItem label="Data operazione">
          <LocalDate v-model="form.date"/>
        </FormItem>

        <FormItem label="">
          <Button type="error" @click.native="form=null">
            Annulla
          </Button>
          &nbsp;
          <Button type="primary" @click.native="dismiss">
            Salva
          </Button>
        </FormItem>
        <Spin size="large" fix v-if="saving"/>
      </Form>
    </Modal>

  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      saving: false,
      items: [],
      filters: {
        company_id: this.$store.company.id,
        active: 1,
        order: {
          by: 'name',
          asc: 1,
        }
      },
      form: null,
      ledgers: [],
      print_loading2: false,
    }
  },

  mounted() {
    this.refreshInventory()
    this.$root.$on('inventory', this.refreshInventory)
    this.$http.get('ledgers', { params: {
      company_id: this.$store.company.id,
      only_pay: 1,
    }}).then(res => {
      this.ledgers = res.data
    })
  },
  beforeDestroy() {
    this.$root.$off('inventory', this.refreshInventory)
  },

  computed: {
    params () {
      return this.filters
    },
  },

  methods: {
    refreshInventory(page) {
      var params = this.params
      this.loading = true
      this.$http.get('inventory', {params}).then(res => {
        this.items = res.data
      }).finally(res => {
        this.loading = false
      })
    },


    dismiss () {
      var form = {
        item_id: this.form.item.id,
        date: this.form.date,
        amount: this.form.amount,
        ledger_id: this.form.ledger_id,
        contact_name: this.form.contact_name,
        op: this.form.op,
      }

      this.saving = true
      this.$http.post('inventory', form).then(res => {
        this.refreshInventory()
        if (this.form.op == 'sell') {
          alert('È stato creato un documento contabile per la vendita, modificabile dalla sezione "prima nota"')
        }
        this.form = null
      }).finally(res => {
        this.saving = false
      })

    },


    orderBy(by) {
      var asc = 0
      if (this.filters.order && this.filters.order.by == by) {
        asc = 1 - this.filters.order.asc
      }
      this.filters.order = { by, asc }
    },

    deleteItem (item, it_i, arr) {
      if (!confirm('Sicuri?')) return
      this.$http.delete('inventory/'+item.id).then(res => {
        arr.splice(it_i, 1)
      })
    }
  },

  watch: {
    filters: {
      deep: true,
      handler: require('lodash').debounce(function() {
        this.refreshInventory()
      }, 300)
    }
  }
}
</script>

<style lang="css">
</style>
